import { LogoLoader } from './LogoLoader';

import { Box, tokens } from '@cast/design-system';

export const SuspenseLoader = () => {
  return (
    <Box
      position="absolute"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor={tokens.theme.bg.structural.page}
      sx={{ inset: 0 }}
      aria-label="loading-spinner"
      data-testid="loading-spinner"
    >
      <LogoLoader />
    </Box>
  );
};
